/**
 * @file 帮助支持
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_HELPAPI_INDEX} from './ActionTypes';

export function fetchHelpapiIndex(dispatch) {
    return rcAjax('GET', '/helpapi/index', {}, {}, data => {
        dispatch({type: GET_HELPAPI_INDEX, data: data.data});
    });
}



// WEBPACK FOOTER //
// ./src/actions/helpAction.js